import React, { useState } from 'react'
import './index.css'
import { Button, Input, Modal } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Register() {
    const [state, setState] = useState({
        accountName: '',
        accountNum: '',
        phone: '',
        password: '',
        confirmPassword: '',
        code: '',
        accountNameTip: '',
        accountNumTip: '',
        phoneTip: '',
        passwordTip: '',
        confirmPasswordTip: '',
        codeTip: '',
        accountName_isVisible: false,
        accountNum_isVisible: false,
        phone_isVisible: false,
        password_isVisible: false,
        confirmPassword_isVisible: false,
        code_isVisible: false,
        modalTitle: '注册成功',
        modalMsg: '点击确认立即跳转到登录页面',
        isnavigate:true
    })
    //输入框赋值
    const inputChange = (event) => {
        const reg = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
        if ("accountName" !== event.target.name) {
            if (!reg.test(event.target.value)) {
                //输入数据不合理
                setState({
                    ...state,
                    [event.target.name + '_isVisible']: true,
                    [event.target.name + 'Tip']: '数据不合规',
                    [event.target.name]: ''
                })
                return;
            }
        }
        if (!event.target.value) {
            setState({
                ...state,
                [event.target.name + '_isVisible']: true,
                [event.target.name]: ''
            })
        } else {
            setState({
                ...state,
                [event.target.name + '_isVisible']: false,
                [event.target.name]: event.target.value
            })
        }
    }
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
        if(state.isnavigate){
            navigate("/login");
        }
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    const registerTo = () => {
        let loginValiad = true;
        //校验
        const { accountName, accountNum, phone, password, confirmPassword, code } = state;
        const items = [
            { id: 'accountName', val: accountName, msg: '请输入商户名称' },
            { id: 'accountNum', val: accountNum, msg: '请输入登录账号' },
            { id: 'phone', val: phone, msg: '请输入手机号' },
            { id: 'password', val: password, msg: '请输入密码' },
            { id: 'confirmPassword', val: confirmPassword, msg: '请再次输入密码' },
            { id: 'code', val: code, msg: '请输入验证码' },
        ];

        items.map(item => {
            if (!item.val) {
                loginValiad = false;
                return setState(prevState => ({ ...prevState, [item.id + '_isVisible']: true, [item.id + 'Tip']: item.msg }));
            }
            return null;
        })
        if (loginValiad) {
            console.log("dddd2222", loginValiad);
            const data = {
                accountNum,
                phone,
                password,
                confirmPassword,
                name: accountName,
                code
            }
            //请求后台接口
            axios.post('/api/register',
                data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
            ).then(
                response => {
                    console.log('注册请求8081成功了', response.data);
                    if (response.data.code === "200") {
                        setState(prevState => ({ ...prevState, modalTitle: "注册成功", modalMsg: "点击确认立即跳转到登录页面",isnavigate:true }));
                        showModal();
                    } else {
                        setState(prevState => ({ ...prevState, modalTitle: "注册失败", modalMsg: response.data.errorMessage,isnavigate:false }));
                        showModal();
                    }

                },
                error => {
                    console.log('注册请求8081失败了', error);
                    navigate("/error");
                }
            )
        }

    }
    return (
        <div className='register-home'>
            <div className='register-header'>
                <div className='header'>
                    <div>
                        对账管理平台LOGO
                    </div>
                    <div className='register-msg'>欢迎注册</div>
                </div>
            </div>

            <div className='register-form'>
                <div className='register-content'>
                    <div className='form-fields'>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>商户名称</span>
                            </div>
                            <div className='field-div-input'>
                                <Input size="large" placeholder="商户名称" name='accountName' value={state.accountName} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>请输入商户名称</span>
                            </div>
                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.accountName_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.accountNameTip}</span>
                                </div>
                            </div>

                        </div>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>账号</span>
                            </div>
                            <div className='field-div-input'>
                                <Input size="large" placeholder="账号" name='accountNum' value={state.accountNum} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>作为登录账号</span>
                            </div>

                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.accountNum_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.accountNumTip}</span>
                                </div>
                            </div>
                        </div>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>手机号</span>
                            </div>
                            <div className='field-div-input'>
                                <Input size="large" placeholder="手机号" name='phone' value={state.phone} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>作为登录手机号</span>
                            </div>

                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.phone_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.phoneTip}</span>
                                </div>
                            </div>

                        </div>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>密码</span>
                            </div>
                            <div className='field-div-input'>
                                <Input size="large" placeholder="密码" name='password' value={state.password} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>密码必须为字母、数字或英文符号,且包含字母和数字,最短8位,区分大小写</span>
                            </div>

                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.password_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.passwordTip}</span>
                                </div>
                            </div>
                        </div>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>确认密码</span>
                            </div>
                            <div className='field-div-input'>
                                <Input size="large" placeholder="确认密码" name='confirmPassword' value={state.confirmPassword} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>请再次输入密码</span>
                            </div>
                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.confirmPassword_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.confirmPasswordTip}</span>
                                </div>
                            </div>
                        </div>
                        <div className='field-div'>
                            <div className='field-div-span'>
                                <span>短信验证码</span>
                            </div>
                            <div style={{ width: '60%', marginLeft: '30px', marginRight: '30px' }}>
                                <Input size="large" placeholder="短信验证码" name='code' value={state.code} onChange={inputChange} />
                            </div>
                            <div style={{ width: '20%', color: '#999' }}>
                                <span>请输入短信验证码</span>
                            </div>
                            <div className='field-div-tip'>
                                <div className='tip-msg'>
                                    <span className={state.code_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>{state.codeTip}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='hava-account'>
                        <span>已有账号？</span>
                        <NavLink to="/login">
                            请登录
                        </NavLink>
                    </div>

                </div>
            </div>
            <div className='register-button'>
                <div style={{ width: '200px' }}>
                    <Button style={{ border: '1px solid  #1677ff' }} block size="large" onClick={registerTo}>提&nbsp;&nbsp;&nbsp;&nbsp;交</Button>
                </div>
            </div>


            <Modal title={state.modalTitle} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} cancelText="取消" okText="确定">
                <p>{state.modalMsg}</p>
            </Modal>
        </div>
    )
}
